import React from 'react'
import OKRs from '../../../components/performance/OKRs'

export default function OKRsPage() {
  return (
    
            <OKRs />
          
  )
}
